 <template>
  <f7-page ref="page" id="asset-info-page" name="asset-info">
    <f7-block>
      <div class="card p-p-3 p-d-flex">


        <f7-link href="/dashboard/"><f7-icon icon="f7-icons p-px-4 icon-arrow-back custom-color"></f7-icon></f7-link>
        

        <span class="p-px-4 custom-color"> Asset name 1</span>
      </div>
    </f7-block>

    <f7-block>
      <f7-row no-gap class="">
        <f7-col width="100" class="padding-right-col" medium="100" large="70" style="height: calc(100vh - 180px);
}">
          <!-- <div class="card card-table">
            <DataTable
              showGridlines
              :value="phaseData"
              rowGroupMode="rowspan"
              groupRowsBy="Phase"
              sortMode="single"
              sortField="Phase"
              :sortOrder="1"
              responsiveLayout="scroll"
            >
              <Column style="text-align: center" field="Phase" header="Phase">
                <template #body="slotProps">
                  <span style="color: #999cb2">{{ slotProps.data.Phase }}</span>
                </template>
              </Column>
              <Column
                style="text-align: center"
                field="OutputV"
                header="Output Voltage (V)"
              ></Column>
              <Column
                style="text-align: center"
                field="CurrentA"
                header="Current I (A)"
              ></Column>
              <Column
                style="text-align: center"
                field="Power"
                header="Power (kW)"
              ></Column>
              <Column
                style="text-align: center"
                field="Frequency"
                header="Frequency (Hz)"
              ></Column>
              <Column
                style="text-align: center"
                field="PowerF"
                header="Power Factor (L)"
              ></Column>
            </DataTable>  
          </div> -->

          <l-map
            ref="map"
            v-model="zoom"
            v-model:zoom="zoom"
            :center="center"
            class="map-square-wrapper card p-mt-4 height-172"
            :zoom-animation="true"
            :options="{ zoomControl: false }"
          >
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :subdomains="tileProvider.subdomains"
              layer-type="base"
            />

            <!-- v-if="locationData.Lat && locationData.Lng" -->
            <l-marker :lat-lng="[42, 42]">
              <l-icon
                :icon-url="iconUrl"
                :icon-size="[40, 40]"
                :icon-anchor="[20, 39]"
              />
            </l-marker>
          </l-map>

          <!-- <f7-row no-gap class="p-mt-4">
            <f7-col width="100" medium="100" large="31">
              <div class="card">
                <div class="card-header">Revolutions per minute</div>

                <vue-gauge
                  :refid="'_' + Math.random().toString(36).substr(2, 9)"
                  :options="optionsGaugeRPM"
                  class="sd"
                />
              </div>
            </f7-col>
            <f7-col width="100" medium="100" large="31">
              <div class="card">
                <div class="card-header">Fuel</div>

                <vue-gauge
                  :refid="'_' + Math.random().toString(36).substr(2, 9)"
                  :options="optionsGaugeFuel"
                />
              </div>
            </f7-col>
            <f7-col width="100" medium="100" large="31">
              <div class="card">
                <div class="card-header">Oil Temp</div>
                <vue-gauge
                  :refid="'_' + Math.random().toString(36).substr(2, 9)"
                  :options="optionsGaugeOil"
                />
              </div>
            </f7-col>
          </f7-row> -->
        </f7-col>

        <f7-col width="100" class="padding-right-col" medium="100" large="30">
          <div class="card">
            <div class="card-header">Status Info</div>

            <Listbox :options="assetInfo" optionLabel="name">
              <template #option="slotProps">
                <div
                  v-if="slotProps.option.mode"
                  class="asset-info-item p-d-flex p-jc-around"
                >
                  <div class="indicator-item">
                    <div 
                    class="circle"
                    :class="slotProps.option.mode.run ? 'bg-green' : 'bg-grey'"></div>
                    <span>MOVING</span>
                  </div>
                  <div class="indicator-item">
                    <div  class="circle"
                    :class="slotProps.option.mode.standby ? 'bg-green' : 'bg-red'"></div>
                    <span>STANDBY</span>
                  </div>
                </div>


                <div v-else-if="slotProps.option.name == 'Alarm'" class="asset-info-item p-d-flex p-jc-between">
                  <div >
                    <i

                      style="margin-right: 10px"
                      :data-icon="slotProps.option.icon"
                      class="icon size-20"
                      :class="slotProps.option.data ? 'color-green' : 'color-lightgrey'"
                    ></i>

                    <span style="color: #9a9ba4">
                      {{ slotProps.option.name }}
                    </span>
                  </div>
                  <div style="max-width: 180px; text-align: right">
                     <f7-toggle color="green" v-model:checked=" slotProps.option.data" />
                  </div>
                
                </div>

                <div v-else class="asset-info-item p-d-flex p-jc-between">
                  <div>
                    <i
                      style="color: #dddee1; margin-right: 10px"
                      :data-icon="slotProps.option.icon"
                      class="icon size-20"
                    ></i>

                    <span st yle="color: #9a9ba4">
                      {{ slotProps.option.name }}
                    </span>
                  </div>
                  <div style="max-width: 180px; text-align: right">
                    <span style="">{{ slotProps.option.data }}</span>
                  </div>
                </div>
              </template>
            </Listbox>
          </div>
        </f7-col>
      </f7-row>
    </f7-block>

    <div class="card"></div>
  </f7-page>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useStore, mapGetters } from "vuex";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Listbox from "primevue/listbox";
import VueGauge from "vue-gauge";
import {
  LMap,
  LIcon,
  LTileLayer,
  LMarker,
  LControlLayers,
  LPopup,
} from "@vue-leaflet/vue-leaflet";

export default {
  name: "asset-info",
  components: {
    DataTable,
    Column,
    LMap,
    LIcon,
    LTileLayer,
    LMarker,
    LControlLayers,
    LPopup,
    Listbox,

    VueGauge,
  },

  directives: {
    // tooltip: Tooltip
  },

  data() {
    const { t } = useI18n();
    return {
      assetInfo: [
        { mode: { run: true, standby: false } },
        // { name: "Run temp", data: "0.0 °C", icon: "n" },
        // {
        //   name: "Ambient temp",
        //   data: "0.0 °C",
        //   icon: "n",
        // },
        // { name: "Coolant temp", data: "0.0 °C", icon: "n" },
   


        { name: "Name", data: "Assetname", icon: "y" },
        {
          name: "Address",
          data: "Sustainable Avenue, Bibra Lake, City Of Cockburn, Western Australia, 6164, Australia",
          icon: "l",
        },
        // {
        //   name: "Coordinates",
        //   data: lat.slice(0, 8) + ", " + lng.slice(0, 8),
        //   icon: "c",
        // },
        { name: "Voltage", data: "0 V", icon: "p" },
        // { name: "Current I", data: "0 A", icon: "d" },
        { name: "ACC", data: "Off", icon: "u" },
        { name: "GPS", data: "0", icon: "h" },
      { name: "Location",  data: "-32.1027, 115.8124", icon: "t" },
      ],
      phaseData: [
        {
          Phase: "L1",
          OutputV: 0,
          CurrentA: 0,
          Power: 0,
          Frequency: 0,
          PowerF: 0,
        },
        {
          Phase: "L2",
          OutputV: 0,
          CurrentA: 0,
          Power: 0,
          Frequency: 0,
          PowerF: 0,
        },
        {
          Phase: "L3",
          OutputV: 0,
          CurrentA: 0,
          Power: 0,
          Frequency: 0,
          PowerF: 0,
        },
      ],
      map: null,
      zoom: 9,
      center: [42, 42],
      iconUrl: "./static/images/pin-red.svg",

      locationData: {},
      tileProviders: [
        {
          name: "Map",
          visible: true,
          url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        },
      ],
      optionsGaugeRPM: {
        chartWidth: 320,
        needleValue: 71.6,
        needleColor: "#dddee1",
        arcDelimiters: [58, 68],
        arcColors: ["rgb(236,238,245)", "rgb(58,181,73)", "rgb(255,0,0)"],
        arcLabels: ["1450", "1700"],
        rangeLabel: ["0", "2500"],
        centralLabel: "1790 RPM",
        rangeLabelFontSize: 10,
      },
      optionsGaugeFuel: {
        chartWidth: 320,
        needleValue: 85,
        needleColor: "#dddee1",
        arcDelimiters: [70],
        arcColors: ["rgb(255,0,0)", "rgb(58,181,73)"],
        arcLabels: ["70"],
        rangeLabel: ["0", "100"],
        centralLabel: "85 L",
        rangeLabelFontSize: 10,
      },
      optionsGaugeOil: {
        chartWidth: 320,
        needleValue: 93.3,
        needleColor: "#dddee1",
        arcDelimiters: [80],
        arcColors: ["rgb(255,0,0)", "rgb(58,181,73)"],
        arcLabels: ["120"],
        rangeLabel: ["0", "150"],
        centralLabel: "140 DEG",
        rangeLabelFontSize: 10,
      },
    };
  },

  computed: {
    ...mapGetters(["MajorToken", "MinorToken"]),
  },

  created() {},

  async mounted() {},
  unmounted() {},
  methods: {},
};
</script>



 